import styles from './Icon.module.css';
import { ICON_TYPE } from './Icon.types';
import { ICON_SIZE } from './ICON_SIZE';

export type IIconSizeStyles = Partial<Record<ICON_SIZE, string>>;
export type IIconTypeStyles = Partial<Record<ICON_TYPE, IIconSizeStyles>>;

export const iconStyles: IIconTypeStyles = {
    [ICON_TYPE.OZ_ARROW_RIGHT]: {
        [ICON_SIZE.SMALL]: styles.arrowHorizontalSmall,
        [ICON_SIZE.MEDIUM]: styles.arrowHorizontalMedium,
        [ICON_SIZE.LARGE]: styles.arrowHorizontalLarge,
    },
    [ICON_TYPE.OZ_ARROW_LEFT]: {
        [ICON_SIZE.SMALL]: styles.arrowHorizontalSmall,
        [ICON_SIZE.MEDIUM]: styles.arrowHorizontalMedium,
        [ICON_SIZE.LARGE]: styles.arrowHorizontalLarge,
    },
    [ICON_TYPE.OZ_ARROW_UP]: {
        [ICON_SIZE.SMALL]: styles.arrowVerticalSmall,
        [ICON_SIZE.MEDIUM]: styles.arrowVerticalMedium,
        [ICON_SIZE.LARGE]: styles.arrowVerticalLarge,
    },
    [ICON_TYPE.OZ_ARROW_DOWN]: {
        [ICON_SIZE.SMALL]: styles.arrowVerticalSmall,
        [ICON_SIZE.MEDIUM]: styles.arrowVerticalMedium,
        [ICON_SIZE.LARGE]: styles.arrowVerticalLarge,
    },
    [ICON_TYPE.OZ_CHECK_MARK]: {
        [ICON_SIZE.SMALL]: styles.checkMarkSmall,
        [ICON_SIZE.MEDIUM]: styles.checkMarkMedium,
    },
    [ICON_TYPE.OZ_TOOLTIP]: {
        [ICON_SIZE.MEDIUM]: styles.tooltipMedium,
        [ICON_SIZE.LARGE]: styles.tooltipLarge,
    },
};
